export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }

  if ((time + '').length === 10) {
    time = +time * 1000
  }

  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    date = new Date(parseInt(time))
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr
}

export function formatTime(time, option) {
  if (time === 0) {
    return ''
  }
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  } else if (diff < 3600 * 24 * 3) {
    return '2天前'
  } else if (diff < 3600 * 24 * 4) {
    return '3天前'
  } else if (diff < 3600 * 24 * 5) {
    return '4天前'
  } else if (diff < 3600 * 24 * 6) {
    return '5天前'
  } else if (diff < 3600 * 24 * 7) {
    return '6天前'
  } else if (diff < 3600 * 24 * 8) {
    return '7天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' +
      d.getMinutes() + '分'
  }
}

export function orderStatusFilter(status) {
  const statusMap = {
    'apply': '已报名，待选会议服务',
    'paid': '已付款',
    'unpaid': '已报名，未付款',
    'seat': '付款并选好座位',
    'service': '已选会议服务',
    'signed': '已签到',
    'offline': '线下支付，等待确认',
    'paying': '付款等待后台确认',
    'trash': '回收站',
    'audit': '审核中'
  }
  return statusMap[status]
}

export function vipOrderStatusFilter(status) {
  const statusMap = {
    'apply': '已申请',
    'paid': '已付款',
    'paying': '付款等待后台确认',
    'audit': '等待审核',
    'unpaid': '未支付',
    'trash': '回收站'
  }
  return statusMap[status]
}

export function vipFilter(vip) {
  const vipMap = {
    '3': '合作伙伴',
    '2': '超级会员',
    '1': '普通会员',
    '0': '免费用户'
  }
  return vipMap[vip]
}

export function mobileFilter(mobile) {
  return mobile.replace(/-+/g, '')
}

export function exhibitorImageTypeFilter(type) {
  const map = {
    'speech': '演讲',
    'booth': '展台',
    'conference': '会刊',
    'publicity': '宣传图',
    'other': '其他'
  }
  return map[type] ? map[type] : type
}

export function statusFilter(status) {
  const statusMap = {
    'show': '公开',
    'hide': '隐藏',
    'trash': '回收站'
  }
  return statusMap[status]
}



// WEBPACK FOOTER //
// ./src/filters/index.js